<template>
  <div class="bg-white rounded">
    <div class="list-group-item">
      <div class="row d-none d-lg-flex">
        <div class="col-lg-3 fw-600">{{ $t("Bill_Type") }}</div>
        <div :class="`col-lg-${showTime?'2':'3'} fw-600`">{{ $t("Before_Money") }}</div>
        <div :class="`col-lg-${showTime?'2':'3'} fw-600`">{{ $t("Deal_Money") }}</div>
        <div :class="`col-lg-${showTime?'2':'3'} fw-600`">{{ $t("After_Money") }}</div>
        <div v-if="showTime" class="col-lg-3 fw-600">{{ $t("Bill_Time") }}</div>
      </div>
    </div>
    <van-list
        :is-edit="false"
        :finished="finished"
        :finished-text="$t('No_More_Data')"
        :offset="500"
        :value="loading"
        @load="onLoad"
    >
      <div v-for="(item, index) in list" :key="index" class="list-group-item">
        <div class="row">
          <div class="d-flex col-lg-3">
            <div class="d-lg-none">{{ $t(`Bill_Type`) }}：</div>
<!--            <zselect :is-edit="false" v-model="item.type" :dict-list="typeEnums"-->
<!--                           list-code="t1" list-label="t2" :placeholder="$t('账变类型')" multiple/>-->
            <zselect v-model="item.type" classname="EnumTradeTypeStore" :colorMap="{}"/>
          </div>

          <div :class="`d-flex col-lg-${showTime?'2':'3'}`">
            <div class="d-lg-none">{{ $t(`Before_Money`) }}：</div>
            {{ formatMoney(item.beforeMoney) }}
          </div>
          <div :class="`d-flex col-lg-${showTime?'2':'3'}`">
            <div class="d-lg-none">{{ $t(`Deal_Money`) }}：</div>
            <span :class="item.money > 0 ? 'text-red' : 'text-green'">{{
                (item.money > 0 ? "+" : "-") + formatMoney(Math.abs(item.money))
              }}</span>
          </div>
          <div :class="`d-flex col-lg-${showTime?'2':'3'}`">
            <div class="d-lg-none">{{ $t(`After_Money`) }}：</div>
            {{ formatMoney(item.afterMoney) }}
          </div>
          <div v-if="showTime" class="d-flex col-lg-3">
            <div class="d-lg-none">{{ $t(`Bill_Time`) }}：</div>
            {{ item.createTime }}
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import {getBillList} from "@/api/user";
import zselect from "@/components/z/zselect.vue";

export default {
  components: {
    zselect,
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      curPage: 0,
      pageSize: 10,
      // typeEnums: [],
    };
  },
  computed:{
    showTime(){
      return this.paramMapAll['USER_BILL_TIME_HIDE'] !== '1'
    },
  },
  methods: {
    onLoad() {
      if (this.finished) return;
      this.curPage++;
      this.loading = true;
      getBillList({
        curPage: this.curPage,
        pageSize: this.pageSize
      }).then(res => {
        let data = res.data;
        data.list && (this.list = this.list.concat(data.list));
        this.loading = false;
        if (this.curPage >= parseInt(data.totalPage)) {
          // 最后一页没有更多了
          this.finished = true;
        }
      });
    },
    // async getTypeEnums() {
    //   this.typeEnums = (await this.$get('/common/dictEnumFull/EnumTradeTypeStore')).data
    // },
  },
  async created() {
    // await this.getTypeEnums()
    this.onLoad();
  }
};
</script>
<style scoped>
.text-red {
  color: red !important;
}

.text-green {
  color: #00a300 !important;
}
</style>
